import { Component, OnInit } from '@angular/core';
import { PersonalProfile } from './personal-profile/personal-profile';
import { ClinicProfile } from './clinic-profile/clinic-profile';
import { User } from '../../core/models/user.model';
import { PortalNavigation, PortalNavigationItem } from '../portal-navigation/portal-navigation';
import { UserManagementService } from '../../core/services/user-management.service';
import { ClinicMembership } from '../../core/models/clinic-membership.model';
import { DoctorProfileService } from '../../core/services/doctor-profile.service';

@Component({
  selector: 'app-profile-view',
  imports: [PersonalProfile, ClinicProfile, PortalNavigation],
  templateUrl: './profile-view.html',
  styleUrl: './profile-view.scss',
})
export class ProfileView {
  activeTab = 'personal';
  userProfile: User | null = null;
  activeRole = 'DOCTOR';
  clinicMemberships: ClinicMembership[] = [];
  readonly clinicNavigationItems: PortalNavigationItem[] = [
    { label: 'Patients', icon: 'bi-people-fill', route: '/dashboard/patients-view' },
    { label: 'Bookings', icon: 'bi-calendar-check-fill', route: '/dashboard/booking-list' },
    { label: 'Create Booking', icon: 'bi-calendar-plus-fill', route: '/dashboard/create-booking' },
  ];
  readonly managerNavigationItems: PortalNavigationItem[] = [
    { label: 'Reporting', icon: 'bi-bar-chart-line', route: '/dashboard/reporting' },
    { label: 'User Management', icon: 'bi-people', route: '/dashboard/manage-users' },
  ];

  constructor(
    private userManagementService: UserManagementService,
    private profileService: DoctorProfileService,
  ) {
    this.loadClinicMemberships();
  }

  private loadClinicMemberships(): void {
    this.userManagementService.getClinicMemberships().subscribe({
      next: (memberships) => {
        this.clinicMemberships = memberships;
      },
      error: () => {
        this.clinicMemberships = [];
      },
    });
  }

  onSwitchClinic(clinicId: string): void {
    this.profileService.switchClinicContext(clinicId);
  }

  setActiveTab(tab: string): void {
    this.activeTab = tab;
  }

  get portalName(): string {
    return `${this.activeRole.charAt(0)}${this.activeRole.slice(1).toLowerCase()} Portal`;
  }

  get portalIcon(): string {
    return this.activeRole === 'MANAGER'
      ? 'bi-clipboard2-pulse-fill'
      : this.activeRole === 'RECEPTION'
        ? 'bi-hospital-fill'
        : 'bi-heart-pulse-fill';
  }

  get portalClass(): string {
    return this.activeRole === 'MANAGER' ? 'text-danger' : 'text-primary';
  }

  get profileRoute(): string {
    return this.activeRole === 'DOCTOR' ? '/dashboard/doctor-profile' : '/dashboard/profile';
  }

  get primaryNavigationItems(): PortalNavigationItem[] {
    return this.activeRole === 'MANAGER' ? [] : this.clinicNavigationItems;
  }

  get additionalNavigationItems(): PortalNavigationItem[] {
    return this.activeRole === 'MANAGER' ? this.managerNavigationItems : [];
  }

  private loadUserProfile(): void {
    const storedProfile = localStorage.getItem('userProfile');
    this.activeRole = localStorage.getItem('userRole') ?? 'DOCTOR';

    if (!storedProfile) {
      return;
    }

    try {
      this.userProfile = JSON.parse(storedProfile) as User;
    } catch {
      this.userProfile = null;
    }
  }
}
